import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import SpdsInputSearch from 'ember-simplepractice/components/spds/input/search';
import styles from './conversation-search.module.scss';

export const MAX_SEARCH_LENGTH = 200;

export default class ConversationSearch extends Component {
  @tracked search = '';

  onInput = event => {
    const { value } = event.target;

    if (value.length > MAX_SEARCH_LENGTH) {
      event.preventDefault();
      const truncated = value.slice(0, MAX_SEARCH_LENGTH);
      event.newValue = truncated;
      event.target.value = truncated;
      this.search = truncated;
      return;
    }

    this.search = value;
  };

  onClearInput = () => {
    this.search = '';
  };

  <template>
    <div class="{{styles.component}} conversation-search" data-test-conversation-search>
      <SpdsInputSearch
        @onClearInput={{this.onClearInput}}
        @onInput={{this.onInput}}
        @placeholder={{t "emc.conversation_list.search_placeholder"}}
        @value={{this.search}}
        class="search-input"
        as |search|
      >
        <search.trigger />
      </SpdsInputSearch>
    </div>
  </template>
}
